<template>
    <div class="card card-round shadow dashboard-widget dashboard-widget--client-invoice dashboard-widget--cumulative-payment">
        <div class="card-header">
            <h6 class="mb-0 fw-bold dashboard-widget__title">
                <span class="dashboard-widget__icon" v-html="sidebarSvg.clientInvoice"></span>
                <span>{{ $t('Cummulative Payment Position') }}</span>
            </h6>
        </div>
        <div class="card-body">
            <div
                class="cumulative-payment__scroll"
                role="region"
                aria-label="Cumulative payment position"
                tabindex="0"
            >
              <div class="cumulative-payment__grid">
                <div class="cumulative-payment__card cumulative-payment__card--total">
                    <span>{{ $t('Total') }}</span>
                    <strong>{{projectInfo.currencyId?.sign}}{{ReformatNumber(data.contractSum + data.variation)}}</strong>
                </div>
                <div class="cumulative-payment__card cumulative-payment__card--paid">
                    <span>{{ $t('Paid') }}</span>
                    <strong>{{projectInfo.currencyId?.sign}}{{ReformatNumber(data.clientPaid)}}</strong>
                </div>
                <div class="cumulative-payment__card cumulative-payment__card--approved">
                    <span>{{ $t('Invoice Approved') }}</span>
                    <strong>{{projectInfo.currencyId?.sign}}{{ReformatNumber(data.approvedInvoice)}}</strong>
                </div>
                <div class="cumulative-payment__card cumulative-payment__card--pending">
                    <span>{{ $t('Invoice to Approve') }}</span>
                    <strong>{{projectInfo.currencyId?.sign}}{{ReformatNumber(data.invoiceToApprove)}}</strong>
                </div>
                <div class="cumulative-payment__card cumulative-payment__card--to-invoice">
                    <span>{{ $t('To Invoice') }}</span>
                    <strong>{{projectInfo.currencyId?.sign}}{{ReformatNumber(data.toInvoice)}}</strong>
                </div>
                <div class="cumulative-payment__card cumulative-payment__card--contract">
                    <span>{{ $t('Contract Sum') }}</span>
                    <strong>{{projectInfo.currencyId?.sign}}{{ReformatNumber(data.contractSum)}}</strong>
                </div>
                <div class="cumulative-payment__card cumulative-payment__card--variation">
                    <span>{{ $t('Variation') }}</span>
                    <strong>{{projectInfo.currencyId?.sign}}{{ReformatNumber(data.variation)}}</strong>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import {DashboardGetProjectCummulativePaymentPosition} from '@/actions/projectActions.js'
import {ReformatNumber} from '../../helpers/utilities.js'
import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
export default {
    name : 'NetCashPosition',
    props : ['projectInfo'],
    data(){
        return {
            data : { 
                approvedInvoice : 0,
                clientPaid : 0,
                contractSum : 0,
                invoiceToApprove : 0,
                toInvoice : 0,
                variation : 0,
            },
            sidebarSvg
            
        }
    },
    mounted : async function(){
        const self = this

        const response = await DashboardGetProjectCummulativePaymentPosition(self.projectInfo._id)
        if(!response)
            return
        self.data = response.data
    },
    methods :{
        ReformatNumber,
    }
    
} 
</script>

<style scoped>
.cumulative-payment__scroll {
    width: 100%;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
    scrollbar-color: #8abaaa #edf5f2;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
}

.cumulative-payment__scroll:focus-visible {
    outline: 2px solid #238a67;
    outline-offset: 2px;
}

.cumulative-payment__grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(8.5rem, 1fr));
    gap: 0.65rem;
    min-width: 39rem;
    padding-bottom: 0.35rem;
}
</style>
